import { render, staticRenderFns } from "./KuCunChaXun.vue?vue&type=template&id=524f9a83&scoped=true&"
import script from "./KuCunChaXun.vue?vue&type=script&lang=js&"
export * from "./KuCunChaXun.vue?vue&type=script&lang=js&"
import style0 from "./KuCunChaXun.vue?vue&type=style&index=0&id=524f9a83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f9a83",
  null
  
)

export default component.exports